import moment from 'moment';

export const formatDatesPayload = (payload) => {
	payload.to = moment(payload.to).endOf('day').toISOString();
	payload.from = moment(payload.from).startOf('day').toISOString();

	return payload;
};
